import React from "react";
import BronTickets from "../modules/BronTickets/BronTickets";

export default function BronTicketsPage() {
  return <BronTickets />;
}
